// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__ZeXMm","slick-next":"CustomSlider_slick-next__k1gw+"};